import {ReducerBuilder} from "@cuatroochenta/co-redux-builders";
import {PagerBackendProps} from "../../../../components/Pager";
import ParkingLossReason from "../../../../commons/model/ParkingLossReason";
import TaskParkingLossReasonList from "../../../../commons/ws/parkingLossReason/TaskParkingLossReasonList";

interface InitialState {
    loading: boolean,
    parkingLossesReasons: ParkingLossReason[],
    error: string,
    pager: PagerBackendProps,
}

const INITIAL_STATE: InitialState = {
    loading: false,
    parkingLossesReasons: [],
    error: '',
    pager: {
        current: 1,
        total_pages: 1,
        total_elements: 0,
    },
};

export default ReducerBuilder.newBuilder(INITIAL_STATE)

    .onEvent(TaskParkingLossReasonList.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState) => {
        return {...oldState, loading: true}
    })
    .onEvent(TaskParkingLossReasonList.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState) => {
        return {...oldState, loading: false}
    })
    .onEvent(TaskParkingLossReasonList.REDUX_ACTION_OBJECT_ON_FAIL, (oldState, payload) => {
        return {...oldState, error: payload}
    })
    .onEvent(TaskParkingLossReasonList.REDUX_ACTION_OBJECT_ON_SUCCESS, (oldState, payload) => {
        return {
            ...oldState,
            parkingLossesReasons: payload.data,
            pager: payload.pager || oldState.pager
        }
    })

    .build()
